import { useState } from 'react';
import { ButtonVariant } from '../../types';
import { Toast } from 'react-bootstrap';
import { Typography } from '../Typography';
import AppButton from 'src/components/base/Button/Button';
import './AppAlert.scss';

type AppAlertProps = {
  className?: string;
  variant?: string;
  props?: any;
  children: any;
  hasButton?: boolean;
  buttonLabel?: string;
  buttonAction?: () => void;
  buttonClass?: string;
  buttonVariant?: ButtonVariant;
  isShow?: boolean;
  toggle?: () => void;
};

const AppAlert: React.FC<AppAlertProps> = ({
  variant,
  className = '',
  children,
  hasButton,
  buttonLabel,
  buttonAction,
  buttonClass = '',
  buttonVariant,
  isShow,
  toggle,
}) => {
  const [show, setShow] = useState<boolean>(
    isShow !== undefined ? isShow : true,
  );

  const toggleShow = () => setShow(!show);

  const handleAction = () => {
    buttonAction && buttonAction();

    toggle ? toggle() : toggleShow();
  };

  return (
    <div className={`custom-alert ${className}`}>
      <Toast
        className={`w-100 bg-${variant || 'primary'} text-${
          variant === 'light' ? 'dark' : 'light'
        }`}
      >
        <Toast.Body className={hasButton ? 'toast-body-has-button' : ''}>
          <div>
            <div className="d-flex align-items-center justify-content-center">
              <Typography
                className={`d-inline-block ${
                  typeof children === 'string' && hasButton
                    ? 'custom-alert-text'
                    : ''
                }`}
                variant="size-16"
                color={
                  variant === 'light'
                    ? 'color-2'
                    : variant === 'link'
                    ? 'color-1'
                    : 'color-3'
                }
                weight="regular"
              >
                {children}
              </Typography>
            </div>
          </div>
          {hasButton && (
            <AppButton
              variant={buttonVariant}
              textSize="size-16"
              label={buttonLabel}
              onClick={handleAction}
              className={`custom-alert-button px-4 py-3 text-uppercase d-block mx-auto cursor-pointer ${buttonClass}`}
            />
          )}
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default AppAlert;
